'use client';

import React, {FC, useState} from 'react';
import classNames from 'classnames';

import Accordion from './Accordion/index';

import styles from './styles.module.scss';

const ACCORDION_DATA: {
  id: number;
  title: string;
  content: string | React.ReactNode;
}[] = [
  {
    id: 1,
    title: 'What is Zoe?',
    content: (
      <>
        Zoe is the modern wealth platform that allows you to find, hire, and
        work with vetted fiduciary financial advisors. Backed by the Opportunity
        Fund, founded by the SoftBank Group, Zoe’s mission is to help grow and
        protect wealth through exceptional client experience and innovative
        technology.
        <br />
        <br />
        Through Zoe’s platform, you can connect with financial advisors across
        the United States based on your unique financial situation.
        <br />
        <br />
        <a href="https://meetings.hubspot.com/alex554/15-minute-consultation-with-a-zoe-advisor-guide?__hstc=181841208.e0e60999b1cae2632de0f8ec1d1999d7.1712269555908.1713883756732.1714077957903.29&__hssc=181841208.3.1714077957903&__hsfp=2174296116&uuid=25f2cd62-06ed-4588-9034-db4228634006">
          Book as many free initial consultations as you need here.
        </a>
      </>
    ),
  },
  {
    id: 2,
    title: 'What sets Zoe’s network of advisors apart?',
    content:
      'Zoe Network financial advisors go through a rigorous screening process in order to join the network. All advisors are either CFP®s, CFAs, or CPAs accredited independent advisors, and have a minimum of 5 years of experience. All advisors are background-checked to ensure they are qualified professionals to assess your finances.',
  },
  {
    id: 3,
    title: 'How much does getting connected cost?',
    content:
      'Zoe is a free service for you to locate the highest quality advisors.',
  },
  {
    id: 4,
    title: 'How long does it take to find the perfect advisor?',
    content:
      'Instantly. Our algorithm immediately matches your financial situation, preferences, and goals with ideal advisors from our network.',
  },
];

const Questions: FC = () => {
  const [selectedItemAccordion, setSelectedItemAccordion] = useState<
    number | null
  >(null);

  const handleClick = (id: number | null) => {
    if (id !== selectedItemAccordion) {
      setSelectedItemAccordion(id);
    } else {
      setSelectedItemAccordion(null);
    }
  };

  return (
    <section className={styles['section-questions']}>
      <div className="default-container">
        <div className={styles['questions']}>
          <div
            className={classNames(
              styles['questions__info'],
              styles['only-tablet'],
            )}>
            <h3>Still have questions?</h3>
          </div>
          <div className={styles['questions__accordion']}>
            <div className="accordion">
              {ACCORDION_DATA.map(({id, title, content}) => {
                return (
                  <Accordion
                    data-testid="accordion"
                    key={id}
                    id={id}
                    handleClick={handleClick}
                    title={title}
                    open={id === selectedItemAccordion}>
                    {content}
                  </Accordion>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Questions;
